var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 870,
    height: 872,
    viewBox: "0 0 870 872",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M869 192.471L442.659 1L11.2119 192.471L442.659 409.471",
    stroke: "#F6F6F6",
    strokeOpacity: 0.7,
    strokeWidth: 0.720588
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M869 345.647L442.659 154.177L11.2119 345.647L442.659 562.647",
    stroke: "#F6F6F6",
    strokeOpacity: 0.7,
    strokeWidth: 0.720588
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M858.788 509.035L432.447 317.565L1 509.035L432.447 726.035",
    stroke: "#F6F6F6",
    strokeOpacity: 0.7,
    strokeWidth: 0.720588
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M858.788 654.554L432.447 463.083L1 654.554L432.447 871.554",
    stroke: "#F6F6F6",
    strokeOpacity: 0.7,
    strokeWidth: 0.720588
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBackground);
export default __webpack_public_path__ + "static/media/LogoBackground.bd2b1694d43aa801c2f8f36fa759dfd7.svg";
export { ForwardRef as ReactComponent };